import React, { Component } from 'react'

export class TickBox extends Component {
  render() {
    return (
      <div className="tickBox">
        <img className="tick" src={require("../../assets/imgs/tick.png")} alt="tickbox" />
        <span className="tickBoxText">
            {this.props.text}
        </span>
      </div>
    )
  }
}

export default TickBox
